import { PAGE_LIST } from 'constants/websites'

export const getPageContentTypes = () => {
  const siteEnv = process.env.NEXT_PUBLIC_SITE_ENVIRONMENT as keyof typeof PAGE_LIST
  return PAGE_LIST[siteEnv] || PAGE_LIST.default
}
